import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import $ from 'jquery';
import _groupBy from 'lodash/groupBy';

import { Grid, MenuItem } from '@mui/material';
import Box from '@mui/material/Box';

import './styles.scss';
import { HTTP_OK } from 'constants/StatusCode.js';
import ValidateEditApply from './ValidateEditApply';
import AlertComponent from 'components/Alert/index.js';
import { DEFAULT_PAGE_MUI } from 'constants/index.js';
import CustomInputYup from 'components/InputYupAndMui/CustomInputYup';
import DateDay from 'components/ReactForm/DateDay';
import CustomRadioInput from 'components/InputYupAndMui/CustomRadioInputForm';
import SelectField from 'components/ReactForm/SelectField';
import { errorSubmit, checkMaxDateToday } from 'helpers';
import {  useListUsers } from 'hook/useMasterData';
import ButtonComponent from 'components/Buttons';
import ModalComponent from 'components/Modal';
import AutoCompleteCustom from 'components/AutoCompleteCustom/AutoComplete.js';
import iconAttchmentCV from 'assets/img/icons/attchment-cv.svg';
import iconCvDefault from 'assets/img/icons/cv-default.svg';
import { apiUpdateApplyInfo, apiUploadCV } from 'api/managerCandidate';
import { USE_GET_DETAIL_CANDIDATE } from 'constants/ManagerCandidate';
import { MAX_LENGTH_30, MAX_LENGTH_250, DEFAULT_LIMIT_10, LOADING_SM } from 'constants/index.js';
import { LIST_YEAR_EXPERIENCE } from 'constants/ManagerCandidate';
import { STATUS_CANDIDATE } from 'constants/ManagerCandidate';
import { SOURCE_CV_TEXT } from 'constants/ManagerCandidate';
import { MAX_LENGTH_50 } from 'constants/index';
import Loading from 'components/Loading';
import { ZERO } from 'constants/MasterData';

const EditApplyModal = (props) => {
  const { isShowModal, setShowModal, uDataPosition, uDataLevel, uDataSkill, uDataListSourceCV, apply } = props;

  const { t } = useTranslation();

  const DEFAULT_VALUES = {
    // position_id: Number(apply?.position_id),
    // skill_id: Number(apply?.skill_id),
    // level_id: Number(apply?.level_id),
    // experience: apply?.experience,
    // source_cv: apply?.source_cv,
    // presenter_id: apply?.presenter_name,
    // apply_date: moment(uDetailCandidate?.apply_date),
    link_cv_online: apply?.link_cv_online,
    pass_prequalification: apply?.status === STATUS_CANDIDATE?.PASS_PRE_QUALIFICATION ? 2 : 1,
    source_cv_text: apply?.source_cv_text,
    presenter_id: apply?.presenter_id,
  };

  const queryClient = useQueryClient();
  const [stateButton, setStateButton] = useState(false);
  const [stateEditButton, setStateEditButton] = useState(true);
  const [isShowAlert, setShowAlert] = useState(false);
  const [isShowAlertError, setShowAlertError] = useState(false);
  const [message, setMessage] = useState('');
  const [attchmentCV, setAttchmentCV] = useState();
  const [sourceCvText, setSourceCvText] = useState('');
  const [namePresenter, setNamePresenter] = useState(apply?.presenter_name);
  const [dataUser, setDataUser] = useState([]);
  const [errorDate, setErrorDate] = useState({});
  const [filter, setFilter] = useState({ page: DEFAULT_PAGE_MUI, limit: DEFAULT_LIMIT_10, key_word: '' });
  const { data: uDataUsers, isLoading: isLoadingDataUsers } = useListUsers({
    key_word: filter.key_word,
    page: filter.page + 1,
    per_page: filter.limit,
  });

  const {
    handleSubmit,
    control,
    register,
    setValue,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(ValidateEditApply(sourceCvText)),
    mode: 'onChange',
    defaultValues: DEFAULT_VALUES,
  });

  useEffect(() => {
    if (uDataUsers?.data) {
      setDataUser((prev) => {
        if (filter.clear_data) {
          return [...uDataUsers?.data];
        }
        return [...prev, ...uDataUsers?.data];
      });
    }
    // eslint-disable-next-line
  }, [uDataUsers]);

  useEffect(() => {
    if (apply?.cv_offline_info) setValue('is_file_upload', true);
    // eslint-disable-next-line
  }, []);

  const radioListPrequalification = [
    {
      value: 2,
      labelName: t('managerCandidate.throughPrequalification'),
    },
    {
      value: 1,
      labelName: t('managerCandidate.didNotPassPrequalification'),
    },
  ];

  const handleSubmitForm = async (dataSubmit) => {
    if (errorDate?.birthday || errorDate?.apply_date) {
      return;
    }
    const {
      source_cv,
      presenter_id,
      apply_date,
      link_cv_online,
      position_id,
      skill_id,
      level_id,
      pass_prequalification,
      experience,
      source_cv_text,
    } = dataSubmit;
    setStateButton(true);
    let response = {};
    const fb = new FormData();
    fb.append('id', apply?.id);
    namePresenter && presenter_id && fb.append('presenter_name', namePresenter);
    apply_date && fb.append('apply_date', moment(apply_date, 'DD/MM/YYYY').format('YYYY/MM/DD'));
    fb.append('link_cv_online', link_cv_online ? link_cv_online : ' ');
    position_id && fb.append('position_id', position_id);
    fb.append('skill_id', skill_id ?? ZERO);
    level_id && fb.append('level_id', level_id);
    source_cv && fb.append('source_cv', source_cv ?? source_cv);
    attchmentCV && fb.append('cv_offline_info', JSON.stringify(attchmentCV));
    attchmentCV && fb.append('cv_offline_info_temp', JSON.stringify(attchmentCV));
    experience && fb.append('experience', experience);
    presenter_id && !sourceCvText && fb.append('presenter_id', presenter_id);
    sourceCvText && fb.append('source_cv_text', source_cv_text);
    pass_prequalification && fb.append('pass_prequalification', Number(pass_prequalification) === 2 ? 1 : 0);

    response = await apiUpdateApplyInfo(fb);

    if (response?.data?.status === HTTP_OK) {
      if (errorSubmit(response?.data?.code)) {
        setMessage(t(errorSubmit(response?.data?.code)));
      } else {
        setMessage(t('managerCandidate.editInfoApplySuccess'));
      }
      setStateButton(false);
      setShowAlert(true);
      clearErrors();
      await queryClient.invalidateQueries(USE_GET_DETAIL_CANDIDATE);
    } else {
      if (errorSubmit(response?.data?.code)) {
        setMessage(t(errorSubmit(response?.data?.code)));
        setShowAlertError(true);
        setStateButton(false);
      }
    }
  };

  const { mutate: uploadCV, isLoading: isLoadingUploadCV } = useMutation((formData) => apiUploadCV(formData), {
    onSuccess: (response) => {
      setAttchmentCV(response.data?.data);
      setError('link_cv_online', '');
      setValue('is_file_upload', true);
    },
    onError: () => {
      setMessage(t('messages.systemError'));
      setShowAlertError(true);
      setAttchmentCV();
      setValue('is_file_upload', false);
    },
  });

  const onUploadAttchmentCV = (event) => {
    if (event.target.files.length > 0) {
      if (event.target.files[0].size / 1024 / 1024 >= 25) {
        $('#attchment-cv').val('');
        setMessage(t('messages.pleaseUploadFileUnder25mb'));
        setShowAlertError(true);
        setAttchmentCV();
        setValue('is_file_upload', false);
        return;
      }

      var regex = new RegExp('(.*?).(docx|doc|pdf|jpg|jpeg|png|xlsx|csv)$');
      if (!regex.test(event.target.files[0].name.toLowerCase())) {
        setMessage(t('messages.pleaseUploadImagesInTheCorrectFormat'));
        setShowAlertError(true);
        setAttchmentCV();
        setValue('is_file_upload', false);
        return;
      }
      if (stateEditButton) {
        setStateEditButton(false);
      }
      const formData = new FormData();
      formData.append('file_cv', event.target.files[0]);
      uploadCV(formData);
    }
  };

  // Watch value type position
  const watchTypePositionIdValue = useWatch({
    control,
    name: 'position_id',
  });

  // Watch value type source_cv
  const watchTypeSourceCvValue = useWatch({
    control,
    name: 'source_cv',
  });

  const watchTypePassPrequalificationValue = useWatch({
    control,
    name: 'pass_prequalification',
  });
  const listSkills = _groupBy(uDataSkill, 'position_id');

  useEffect(() => {
    if (watchTypePassPrequalificationValue && stateEditButton) {
      setStateEditButton(false);
    }
    // eslint-disable-next-line
  }, [watchTypePassPrequalificationValue]);

  useEffect(() => {
    setValue(
      'is_skill',
      uDataSkill?.filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))?.length > 0
        ? true
        : false,
    );
    if (!watchTypePositionIdValue || !listSkills[watchTypePositionIdValue]) {
      setValue('skill_id', null);
    } else if (apply?.skill_id && watchTypePositionIdValue === apply?.position_id) {
      let skill = listSkills[watchTypePositionIdValue].find((item) => item.id === apply?.skill_id);
      if (skill) setValue('skill_id', skill.id);
      else setValue('skill_id', null);
    } else {
      setValue('skill_id', listSkills[watchTypePositionIdValue][0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchTypePositionIdValue]);

  // useEffect(() => {
  //   setValue('position_id', uDetailCandidate?.position_id);
  //   setValue('skill_id', uDetailCandidate?.skill_id);
  //   setValue('level_id', uDetailCandidate?.level_id);
  //   setValue('source_cv', uDetailCandidate?.source_cv);
  //   if (apply?.cv_offline_info) {
  //     setValue('is_file_upload', true);
  //   }
  //   // eslint-disable-next-line
  // }, [uDetailCandidate]);

  // Watch value birthday
  const watchApplyDateValue = useWatch({
    control,
    name: 'apply_date',
  });

  useEffect(() => {
    // eslint-disable-next-line
    if (!watchApplyDateValue || watchApplyDateValue == 'Invalid Date' || watchApplyDateValue?.length < 10) {
      return;
    }
    if (watchApplyDateValue?.length === 10) {
      if (checkMaxDateToday(watchApplyDateValue)) {
        setErrorDate((prev) => {
          return { ...prev, apply_date: true };
        });
      } else {
        setErrorDate((prev) => {
          return { ...prev, apply_date: false };
        });
      }
    }
  }, [watchApplyDateValue]);

  const onHandleChangeSelect = (value) => {
    let data = uDataListSourceCV.filter((item) => (item.id === value ? item.name : null));
    if (data?.length && SOURCE_CV_TEXT.indexOf(data[0].name.toLowerCase()) > -1) {
      setSourceCvText(value);
    } else {
      setSourceCvText('');
    }
  };

  return (
    <>
      <ModalComponent
        toggle={() =>
          setShowModal((prev) => {
            return { ...prev, edit_apply: !isShowModal };
          })
        }
        isShowModal={isShowModal}
        title={t('managerCandidate.editInfoApply')}
        classNameAdd="modal-create-candidate"
      >
        <Box autoComplete="off" onSubmit={handleSubmit(handleSubmitForm)}>
          <Grid container spacing={3}>
            <Grid item xs={12} className="text-modal item-field">
              {t('managerCandidate.inforApply')}
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="position_id"
                label={t('masterData.StandardIndex.position')}
                error={errors?.position_id?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                isShowModal={isShowModal}
                onHandleSelect={() => {
                  if (stateEditButton) {
                    setStateEditButton(false);
                  }
                }}
                defaultValue={Number(apply?.position_id)}
                isRequired
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: {
                        xs: 350,
                      },
                    },
                  },
                }}
              >
                {uDataPosition?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="skill_id"
                label={t('masterData.StandardIndex.skill')}
                error={errors?.skill_id?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                onHandleSelect={() => {
                  if (stateEditButton) {
                    setStateEditButton(false);
                  }
                }}
                isShowModal={isShowModal}
                defaultValue={apply?.skill_id ?? ''}
                disabled={
                  watchTypePositionIdValue &&
                  uDataSkill?.filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))?.length > 0
                    ? false
                    : true
                }
                isRequired={
                  watchTypePositionIdValue &&
                  uDataSkill?.filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))?.length > 0
                    ? true
                    : false
                }
              >
                {uDataSkill &&
                  uDataSkill
                    ?.filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))
                    ?.map((item) => (
                      <MenuItem value={item.id} key={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
              </SelectField>
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="level_id"
                label={t('masterData.StandardIndex.levelApply')}
                error={errors?.level_id?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                onHandleSelect={() => {
                  if (stateEditButton) {
                    setStateEditButton(false);
                  }
                }}
                isShowModal={isShowModal}
                defaultValue={apply?.level_id}
                isRequired
              >
                {uDataLevel?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="experience"
                label={t('managerJD.experience')}
                error={errors?.experience?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                onHandleSelect={() => {
                  if (stateEditButton) {
                    setStateEditButton(false);
                  }
                }}
                defaultValue={apply?.experience}
                isShowModal={isShowModal}
                isRequired
              >
                {LIST_YEAR_EXPERIENCE?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            <Grid item md={12} className="item-field">
              <SelectField
                name="source_cv"
                label={t('managerCandidate.sourceCv')}
                error={errors?.source_cv?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                onHandleSelect={() => {
                  if (stateEditButton) {
                    setStateEditButton(false);
                  }
                }}
                defaultValue={apply?.source_cv}
                isShowModal={isShowModal}
                isRequired
                onHandleChangeSelect={onHandleChangeSelect}
              >
                {uDataListSourceCV?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            {sourceCvText && (
              <Grid item md={12} className="item-field">
                <CustomInputYup
                  label={t('managerCandidate.Outsourcing/contributor/headhunt')}
                  name={`source_cv_text`}
                  maxLength={MAX_LENGTH_50}
                  errors={errors}
                  control={control}
                  register={register}
                  useWatch={useWatch}
                  required
                />
              </Grid>
            )}
            {watchTypeSourceCvValue === 1 && (
              <Grid item md={12} className="item-field">
                <AutoCompleteCustom
                  label={t('managerCandidate.fullNameIntroduce')}
                  options={dataUser}
                  setFilter={setFilter}
                  setValueField={setValue}
                  register={register}
                  name="presenter_id"
                  total={uDataUsers?.total}
                  isLoading={isLoadingDataUsers}
                  error={errors?.presenter_id?.message}
                  setDataUser={setDataUser}
                  maxLength={MAX_LENGTH_30}
                  defaultValue={apply?.presenter_name}
                  onHandleSelect={() => {
                    if (stateEditButton) {
                      setStateEditButton(false);
                    }
                  }}
                  setNamePresenter={setNamePresenter}
                  required={watchTypeSourceCvValue === 1 ? true : false}
                  namePresenter={namePresenter}
                  clearErrors={clearErrors}
                />
              </Grid>
            )}
            <Grid item md={12} className="item-field">
              <DateDay
                label={t('managerCandidate.dateApply')}
                name="apply_date"
                error={errors?.apply_date?.message}
                addErrors={errorDate?.apply_date && t('messages.pleaseEnteraDateThatIsLessThanTheCurrentDate')}
                control={control}
                setValue={setValue}
                onChangeHandle={() => {
                  if (stateEditButton) {
                    setStateEditButton(false);
                  }
                }}
                setError={setError}
                register={register}
                isShowModal={isShowModal}
                defaultValue={moment(apply?.apply_date)}
                maxDate={moment()}
                isRequired
              />
            </Grid>
            <Grid item xs={12} className="text-modal">
              {t('managerCandidate.infoCV')}
            </Grid>
            <Grid item md={12} className="item-field link-cv-input">
              <CustomInputYup
                label={t('managerCandidate.linkAttchment')}
                name={`link_cv_online`}
                control={control}
                register={register}
                errors={errors}
                onHandelChange={() => {
                  if (stateEditButton) {
                    setStateEditButton(false);
                  }
                }}
                defaultValue={apply.link_cv_online ? apply?.link_cv_online : ''}
                addErrors={!attchmentCV && errors?.name?.link_cv_online}
                useWatch={useWatch}
                required={apply?.cv_offline_info ? false : attchmentCV ? false : true}
                maxLength={MAX_LENGTH_250}
              />
            </Grid>
            <Grid item xs={12} className="text-modal item-field">
              <input
                id={'attchment-cv'}
                type="file"
                name="attchment_cv"
                style={{ display: 'none' }}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.csv"
                onChange={(event) => onUploadAttchmentCV(event)}
              />
              <label className="upload-file-cv" htmlFor={'attchment-cv'}>
                {<img src={iconAttchmentCV} alt="camera" width={'18px'} height="18px" />}{' '}
                {t('managerCandidate.upFileCvAttchment')}
                <label className="label-CV" htmlFor={'attchment-cv'}>
                  {t('managerCandidate.typeFileAccept')}
                </label>
              </label>
              {isLoadingUploadCV && <Loading type={LOADING_SM} addClass="loading-upload-cv" />}
              {!isLoadingUploadCV && attchmentCV && (
                <div className="info-cv-upload">
                  <div>
                    <img src={iconCvDefault} alt="camera" width={'60px'} height="60px" />
                  </div>
                  <div className="cv-name">
                    <p className="title">{attchmentCV.name}</p>
                    <p>{attchmentCV.size + ' kb'}</p>
                  </div>
                </div>
              )}
              {apply?.cv_offline_info && !attchmentCV && (
                <div className="info-cv-upload">
                  <div>
                    <img src={iconCvDefault} alt="camera" width={'60px'} height="60px" />
                  </div>
                  <div className="cv-name">
                    <p className="title">{JSON.parse(apply?.cv_offline_info)?.name}</p>
                    <p>{JSON.parse(apply?.cv_offline_info)?.size + ' kb'}</p>
                  </div>
                </div>
              )}
            </Grid>
            <Grid item xs={12} className="text-modal">
              {t('managerCandidate.prequalification')}
            </Grid>
            <Grid item xs={12} className="text-modal item-field">
              <CustomRadioInput
                control={control}
                radioList={radioListPrequalification}
                defaultValue={apply?.status}
                name="pass_prequalification"
                setValue={setValue}
              />
            </Grid>
            <Grid item md={6}>
              <ButtonComponent
                text={t('managerJD.cancel')}
                addClass="button-cancel btn-bg-yellow2"
                handleClick={() =>
                  setShowModal((prev) => {
                    return { ...prev, edit_apply: false };
                  })
                }
              />
            </Grid>
            <Grid item md={6}>
              <ButtonComponent
                text={t('common.save')}
                addClass="button-submit btn-bg-yellow1"
                type="submit"
                handleClick={handleSubmit(handleSubmitForm)}
                hasDisabled={stateButton || stateEditButton}
                isLoading={stateButton}
              />
            </Grid>
          </Grid>
        </Box>
      </ModalComponent>
      <AlertComponent
        toggle={() => {
          setShowAlert(!isShowAlert);
          setShowModal((prev) => {
            return { ...prev, edit_apply: false };
          });
        }}
        isShowAlert={isShowAlert}
      >
        {message}
      </AlertComponent>
      <AlertComponent
        toggle={() => {
          setShowAlertError(!isShowAlertError);
        }}
        isShowAlert={isShowAlertError}
      >
        {message}
      </AlertComponent>
    </>
  );
};

export default EditApplyModal;
